import { render } from "./InputTreatment.vue?vue&type=template&id=4a06f868"
import script from "./InputTreatment.vue?vue&type=script&lang=js"
export * from "./InputTreatment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__